import { CarrierResponse } from '@/types/carrier.type'
import { api } from './api'

export const getCarriers = (): Promise<CarrierResponse> => api.get('/carrier')
